<div id="insomnia">
  <img src="assets/img/insomnia19/insomnia-banner.jpg" class="img-responsive hidden-xs" alt="">

  <img src="assets/img/insomnia19/insomnia-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md"
       alt="">
  <div class="go_button orange sm square" style="position:absolute; top:20px; left:20px;">
    <i class="icon-facebook" (click)="eventService.shareEvent()">Share</i>
  </div>
  <div class="container">
    <perfect-scrollbar class="games-container">
      <div class="cliped-hexagon-container">
        <a class="cliped-hexagon" routerLink="./{{game}}" routerLinkActive="active" *ngFor="let game of games">
          <div class="hexagon-background"
               [ngStyle]="{'background-image': 'url(assets/img/insomnia19/games/'+game+'/sm.jpg)'}"></div>
          <img src="assets/img/games/{{game}}/logo.png" width="110" alt="" style="z-index: 1">
        </a>
      </div>
    </perfect-scrollbar>
  </div>
  <div class="container">
    <div class="row">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!--footer-->
  <div class="insomnia_footer">
    <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg"
                                                                           style="width: 80px" alt="GBarena Logo"></a>

    <!--<p>Halloween Nights is hosted and powered by GBarena</p>-->


  </div>
</div>
